<template>
    <div>
        <template v-if="activity.actor === 'visitor'">
            <!--            <strong>{{ $_.get(activity, "refVisitor.fullname") }} </strong>-->
            <!--            started-->
            <!--            <strong>-->
            <!--                {{ $_.startCase($_.get(activity, "payload.ref")) }}-->
            <!--            </strong>-->
            <!--            chat-->
            <span
                v-html="$t('notification.chatOpenedByVisitor', { visitor: getVisitorName, platform:$_.get(activity, 'payload.ref') })"></span>
        </template>
        <template v-if="activity.actor === 'user'">
            <!--            <strong>-->
            <!--                {{ $_.startCase($_.get(activity, "payload.ref")) }}-->
            <!--            </strong>-->
            <!--            Chat started with-->
            <!--            <strong>{{ $_.get(activity, "refVisitor.fullname") }} </strong>-->
            <!--            by-->
            <!--            <strong>{{ $_.get(activity, "actorUser.name") }} </strong>-->
            <span
                v-html="$t('notification.chatOpenedByAgent', { agent:$_.get(activity, 'actorUser.name'), visitor:$_.get(activity, 'refVisitor.fullname'),platform:$_.get(activity, 'payload.ref') })"></span>
        </template>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatOpened",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {},
    computed: {
        getVisitorName() {
            if (this.$_.get(this.activity, "refVisitor.fullname") !== "") {
                console.log("whatsappAcitivityNumberLog",{item : this.$_.get(this.activity, "refVisitor.whatsappNumber")})
                return this.$_.get(this.activity, "refVisitor.fullname");
            } else {
                return this.$_.get(this.activity, "refVisitor.whatsappNumber");
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
